export enum PlatformType {
  tag = 'TAG',
  fs = 'FS',
  both = 'BOTH',
  fsToken = 'FS_TOKEN',
}

export type PlatformData = {
  type?: PlatformType;
  tagUrl?: string;
  fsUrl?: string;
};
